import * as dashboardService from './service/dashboard.service';

const state = {
	loadingReport: false,
};

const mutations = {
	SET_LOADING_REPORT(state, value) {
		state.loadingReport = value;
	},
};

const actions = {
	async exportDashboardReport({ commit }, params) {
		commit('SET_LOADING_REPORT', true);
		try {
			const result = await dashboardService.exportDashboardReport(params);
			return result;
		} finally {
			commit('SET_LOADING_REPORT', false);
		}
	},
};

const getters = {};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
